import classNames from 'classnames';
import React from 'react';
import styles from './ParameterDetails.module.scss';
function ParameterDetails({ direction = 'vertical', size = 'm', label, value, }) {
    return (React.createElement("div", { className: classNames(styles.wrap, styles[size], styles[direction]) },
        label && (React.createElement("label", { htmlFor: label, className: styles.label }, label)),
        React.createElement("p", { className: classNames(styles.value, { [styles.fullWidth]: !label }) }, value || '-')));
}
export default ParameterDetails;
